import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useOrderCreation = ({
  onSuccess,
}: {
  onSuccess: (data: { orderId: string }) => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (data: { clientId: string; billTo?: string }) =>
      OrdersClient.create(data),
    onSuccess,
  });

  return {
    createOrder: mutate,
    isLoading: isPending,
  };
};
